"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _componentLibrary = require("@sunrun/component-library");

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _json2csv = require("json2csv");

var _breakpoints = require("../constants/breakpoints");

var _templateObject, _templateObject2, _templateObject3;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

// display none will be added back in when we have cumulative in download
var Wrap = _styled["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  @media only screen and (max-width: ", ") {\n    display: ", ";\n  }\n"])), _breakpoints.MAX_DESKTOP_BREAKPOINT, function (props) {
  return props.hideMobile ? 'none' : 'block';
});

var Container = _styled["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 100%;\n"])));

var DownloadButton = _styled["default"].button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  background: transparent;\n  border: none;\n  color: transparent;\n  cursor: pointer;\n  margin: 0;\n  padding: 0;\n  outline: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n"])));

var DownloadCsv = function DownloadCsv(_ref) {
  var children = _ref.children,
      className = _ref.className,
      data = _ref.data,
      disabled = _ref.disabled,
      fields = _ref.fields,
      fileName = _ref.fileName,
      onDownloadClick = _ref.onDownloadClick,
      styles = _ref.styles,
      hideMobile = _ref.hideMobile;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      encodedUri = _useState2[0],
      setEncodedUri = _useState2[1];

  var linkElement = /*#__PURE__*/(0, _react.createRef)();
  (0, _react.useEffect)(function () {
    if (encodedUri) {
      linkElement.current.click();
      setEncodedUri(null);
    }
  }, [encodedUri]);

  var handleClick = function handleClick() {
    if (onDownloadClick) {
      onDownloadClick();
    }

    if (data) {
      (0, _json2csv.parseAsync)(data, {
        fields: fields
      }).then(function (csv) {
        setEncodedUri("data:text/csv;charset=utf-8,".concat(encodeURIComponent(csv)));
      });
    }
  };

  var styleProps = _defineProperty({}, styles, true);

  if (styles) {
    return /*#__PURE__*/_react["default"].createElement(Wrap, {
      hideMobile: hideMobile
    }, /*#__PURE__*/_react["default"].createElement(Container, {
      "data-tour": "download-button"
    }, encodedUri && /*#__PURE__*/_react["default"].createElement("a", {
      ref: linkElement,
      download: "".concat(fileName, ".csv"),
      href: encodedUri
    }), /*#__PURE__*/_react["default"].createElement(_componentLibrary.Button, _extends({}, styleProps, {
      disabled: disabled,
      title: "".concat(fileName, ".csv"),
      onClick: handleClick,
      className: className
    }), children)));
  }

  return /*#__PURE__*/_react["default"].createElement(Wrap, {
    hideMobile: hideMobile
  }, encodedUri && /*#__PURE__*/_react["default"].createElement("a", {
    ref: linkElement,
    download: "".concat(fileName, ".csv"),
    href: encodedUri
  }), /*#__PURE__*/_react["default"].createElement(DownloadButton, {
    className: className,
    "data-tour": "download-button",
    onClick: handleClick,
    title: "".concat(fileName, ".csv")
  }, children));
};

DownloadCsv.propTypes = {
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]),
  data: _propTypes["default"].arrayOf(_propTypes["default"].shape({})),
  disabled: _propTypes["default"].bool,
  fields: _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].shape({}), _propTypes["default"].string])).isRequired,
  fileName: _propTypes["default"].string.isRequired,
  onDownloadClick: _propTypes["default"].func,
  styles: _propTypes["default"].oneOf(['primary', 'secondary', 'tertiary']),
  hideMobile: _propTypes["default"].bool
};
DownloadCsv.defaultProps = {
  className: '',
  data: null,
  disabled: false,
  onDownloadClick: null,
  styles: null,
  hideMobile: false
};
var _default = DownloadCsv;
exports["default"] = _default;